import React, { useEffect, useState, useContext } from 'react';
import ReactPlayer from 'react-player';
import { api } from '../utils/apiHelper';
import UserContext from '../context/UserContext';
import '../styles/Farmereps.css';

const FarmerEps = () => {
  const { authUser } = useContext(UserContext);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   
    const fetchVideos = async () => {
  try {
    const res = await api('/get-farmertv-public');
    setVideos(res?.farmVid || []);
  } catch (err) {
    console.error('Failed to fetch videos:', err.message);
  } finally {
    setLoading(false);
  }
};

    fetchVideos();
  }, [authUser]);

  if (loading) return <p>Loading episodes...</p>;

  return (
    <div className="farmer-eps-container">
      {videos.length === 0 ? (
        <p>No episodes uploaded yet.</p>
      ) : (
        videos.map((vid) => (
          <div key={vid.fileId} className="episode-card">
            <div className="episode-details">
              <h3 className="farmerTitle">
                <span style={{ fontWeight: '750' }}>Title:</span> {vid.fileTitle}
              </h3>

              <ReactPlayer
                url={vid.url}
                controls
                width="100%"
                height="auto"
              />

              <p className="desc">{vid.fileDescription}</p>
              <p>
                Uploaded by <strong>{vid.userName}</strong> on{' '}
                {new Date(vid.createdAt).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default FarmerEps;
